module.exports = __webpack_public_path__ + "static/img/ISAAC-WALLER.f026eab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISAAC-WALLER.jpg
// module id = lGgB
// module chunks = 0